module.exports = __webpack_public_path__ + "static/img/ussc-last-icon.999b4826.png";